import type {State} from 'src/reducers';
import type {
  GenericError,
  ReferralLinks,
  EarningsData,
  PaymentDetails,
  AgencyList,
  UserDetails,
} from 'src/types/referrer-portal';
import type {
  ReferralPrograms,
  GetReferralTrackingApiResponse,
} from 'src/types/referral-v2';
import type {JobResponse} from 'src/types/referral-external';


export const selectSocialLinks = (state: State): ReferralLinks =>
  //@ts-expect-error
  state.referrerPortal?.referral_social_links;

export const selectEarnings = (state: State): EarningsData =>
  //@ts-expect-error
  state.referrerPortal?.earnings;

export const selectPaymentDetails = (state: State): PaymentDetails[] =>
  //@ts-expect-error
  state.referrerPortal?.payment_details;

export const selectAgencyList = (state: State): AgencyList[] =>
  //@ts-expect-error
  state.referrerPortal?.agency_list;

export const selectAgencyReferralProgram = (state: State): ReferralPrograms[] =>
  //@ts-expect-error
  state.referrerPortal?.agency_programs;

export const selectNotification = (
  state: State,
): {
  [key: string]: boolean;
  //@ts-expect-error
} => state.referrerPortal?.notification;

export const selectJobs = (state: State): JobResponse[] =>
  //@ts-expect-error
  state.referrerPortal?.jobs;

export const selectReferralRequest = (
  state: State,
): GetReferralTrackingApiResponse =>
  //@ts-expect-error
  state.referrerPortal?.referral_tracking_details;

export const selectUserDetails = (state: State): UserDetails =>
  //@ts-expect-error
  state.referrerPortal?.account;

export const selectUserDetailsError = (state: State): GenericError =>
  //@ts-expect-error
  state.referrerPortal?.account_error;
